import React from 'react';
import PropTypes from 'prop-types';
import PortalModal from 'components/Modals/PortalModal';
import { withRouter } from 'react-router-dom';

const deleteEntryModalDefaultPropHandleDeleteConfirmation = () => {};
const DeleteEntryModal = ({
  open,
  close,
  yieldEntryId = '',
  handleDeleteConfirmation = deleteEntryModalDefaultPropHandleDeleteConfirmation,
  title = '',
  confirmLabel = '',
  isSaving = false
}) => {
  const handleCancel = () => {
    close();
  };

  return (
    <PortalModal
      open={open}
      title={title}
      close={handleCancel}
      cancelLabel="Cancel"
      confirmLabel={confirmLabel}
      onCancel={() => handleCancel()}
      type="error"
      onConfirm={() => handleDeleteConfirmation(yieldEntryId)}
      isSaving={isSaving}
    >
      <div data-testid="yield-entry-deleteModal" className="pr-6">
        Are you sure you want to delete this yield data? All of the data
        associated with this entry will be lost.
      </div>
    </PortalModal>
  );
};

DeleteEntryModal.propTypes = {
  title: PropTypes.string,
  confirmLabel: PropTypes.string,
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired,
  open: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]).isRequired,
  close: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]).isRequired,
  yieldEntryId: PropTypes.string,
  handleDeleteConfirmation: PropTypes.func,
  isSaving: PropTypes.bool
};

export default withRouter(DeleteEntryModal);
